import {CarrierPrice} from "./CarrierPrice";
import {FormField} from "./FormField";
import {ParcelType} from "./ParcelType";
import {Country} from "./Fields/Country";
import {Loader} from "./Loader";
import {PackageWidth, PackageHeight, PackageLength} from "./Fields/PackageSizeFields";
import {quotation} from "../DataSource/quotation";
import {ErrorBag, Validator} from "./Validator";
import * as yup from 'yup';
import submitForm from 'submit-form';
import {debounce} from "debounce";

require('../../sass/components/_quickOrderForm.scss');
require('../../sass/components/_select.scss');


function sortCheapestCarrier(carriers) {
    if (!Array.isArray(carriers)) {
        return;
    }
    return carriers.sort((a, b) => a.total - b.total);
}


function getCheapestCarrier(carriers) {
    if (!Array.isArray(carriers)) {
        return;
    }
    return carriers.sort((a, b) => a.total - b.total)[0];
}

function filterOutProductWithoutOffer(x) {
    return x.no_offer !== true;
}

const PriceInfoV3 = {
    name: 'PriceInfoV3',
    components: {
        Loader
    },
    props: {
        isLoading: Boolean,
        carrierSelect: {
            type: Object,
            default: null
        }
    },
    computed: {
        price() {
            if(this.carrierSelect){
                return this.carrierSelect.total + ' zł';
            } else {
                return 'Brak ofert';
            }
        }
    },
    template: `
        <div class="quick-order-form__price-info--v3">
            <div class="quick-order-form__price-info__description">Cena od:</div>
            <Loader v-if="isLoading" size="small"/>
            <div class="quick-order-form__price-info__price-range" v-if="!isLoading">{{price}}</div>
        </div>
    `
};

export const QuickOrderForm = {
    name: 'QuickOrderForm',
    components: {
        FormField,
        ParcelType,
        Country,
        PriceInfoV3,
        PackageWidth,
        PackageLength,
        PackageHeight
    },
    props: {
        ABVersion: String,
        defaultValue: Object,
        baseUrl: String
    },
    data() {
        return {
            value: {
                package_type: 1,
                weight: 1,
                width: 20,
                height: 8,
                length: 25,
                countryFrom: 'PL',
                countryTo: 'PL',
                ...(this.defaultValue || {})
            },
            isLoading: false,
            quotation: undefined,
            errors: new ErrorBag(),
            carrierNames: {
                'dhl': {
                    'name': 'DHL',
                    'subname': null
                },
                'ups': {
                    'name': 'UPS',
                    'subname': null
                },
                'fedex': {
                    'name': 'FedEx',
                    'subname': null
                },
                'gls': {
                    'name': 'GLS',
                    'subname': null
                },
                'dpd': {
                    'name': 'DPD',
                    'subname': null
                },
                'inpost': {
                    'name': 'InPost',
                    'subname': 'Paczkomat'
                },
                'kurier_inpost': {
                    'name': 'InPost',
                    'subname': 'Kurier'
                },
                'orlen': {
                    'name': 'ORLEN',
                    'subname': 'Paczka'
                },
                'ambro': {
                    'name': 'AMBRO',
                    'subname': 'Express'
                },
            },
            carrierSelect: null,
            isFixed: false,
            bottomPosition: 0,
            manually: false
        };
    },
    mounted() {
        this.validator = new Validator(
            yup.object({
                weight: yup.number()
                    .required()
                    .typeError(),
                length: yup.number()
                    .required()
                    .typeError()
                    .min(1),
                height: yup.number()
                    .required()
                    .typeError()
                    .min(1),
                width: yup.number()
                    .required()
                    .typeError()
                    .min(1),
            })
        );
        this.errors = this.validator.errors;
        this.load();

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.calculateBottomPosition);

        const targetNode = this.$refs.stickyDiv;
        const observer = new MutationObserver(function(mutationsList, observer) {
            this.calculateBottomPosition();
            this.handleScroll();
        }.bind(this));
        observer.observe(targetNode, { childList: true, subtree: false, characterData: false });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.calculateBottomPosition);
    },
    methods: {

        calculateBottomPosition() {
            const el_carriers = this.$el.querySelector('.quick-order-form__prices');
            const el = this.$el.querySelector('.quick-order-form__price-sticky');
            // console.log(el.offsetTop, el.offsetHeight);
            this.bottomPosition = el_carriers.offsetTop + el_carriers.offsetHeight + el.offsetHeight;
        },
        handleScroll() {
          const y = window.scrollY + window.innerHeight;
          this.isFixed = y <= this.bottomPosition;
        },

        load() {
            this.validate()
                .then(isValid => {
                    if (!isValid) {
                        // create empty result to indiate lack of products
                        this.quotation = {products: []};
                        return;
                    }

                    this.isLoading = true;

                    quotation({
                        sender: {
                            country: this.value.countryFrom
                        },
                        recipient: {
                            country: this.value.countryTo
                        },
                        params: {
                            weight: this.value.weight,
                            height: this.value.height,
                            length: this.value.length,
                            width: this.value.width,
                            package_type: this.value.package_type,
                            count: 1,
                            packing_type: 1,
                            content: ""
                        },
                        services: {}
                    })
                        .then(result => {
                            this.isLoading = false;
                            this.quotation = result;

                            sortCheapestCarrier(this.carriers);

                            if(!!this.carrierSelect) {
                                const checked = this.carriers.find(obj => obj.carrier_code === this.carrierSelect.carrier_code);
                                if (!!checked && this.manually) {
                                    this.setCarrierSelect(checked);
                                } else {
                                    this.setDefaultCarrierSelect(this.quotation.default);
                                }
                            } else {
                                this.setDefaultCarrierSelect(this.quotation.default);
                            }

                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                })
        },
        setDefaultCarrierSelect(_default) {
            const checked = this.carriers.find(obj => obj.carrier_code === _default.carrier_code);
            if(!!checked) {
                this.setCarrierSelect(checked);
            } else {
                this.setCarrierSelect(this.carriers[0]);
            }
        },
        validateField(field) {
            return this.validator.validateField(field, this.value);
        },
        validate() {
            return this.validator.validate(this.value);
        },
        onSubmit() {},
        submit() {
            this.validate()
                .then(isValid => {
                    if (!isValid) {
                        return;
                    }
                    const data = {
                        params: {
                            length: this.value.length,
                            width: this.value.width,
                            height: this.value.height,
                            weight: this.value.weight,
                            package_type: this.value.package_type,
                        },
                        sender: {
                            country: this.value.countryFrom,
                        },
                        recipient: {
                            country: this.value.countryTo
                        },
                        product_id: this.carrierSelect.product_id,
                        collection_date: null
                    };

                    if(this.$parent.type === 'widget')
                    {
                        let target = '_blank'
                        if(this.$parent.$el.classList.contains('same_tab')) {
                            target = '_self';
                        }
                        window.open((this.baseUrl || '') + 'zloz-zamowienie?d=' + JSON.stringify(data), target);
                    }
                    else
                    {
                        submitForm((this.baseUrl || '') + 'zloz-zamowienie', {
                            method: 'GET',
                            body: {
                                d: JSON.stringify(data)
                            }
                        });
                    }

                });
        },
        setCountries(from, to) {
            this.value.countryFrom = from;
            this.value.countryTo = to;
        },
        onTypeChange(type) {
            switch (type) {
                case 1:
                    this.value = {
                        ...this.value,
                        package_type: type,
                        length: '25',
                        width: '20',
                        height: '8',
                        weight: '1'
                    };
                    break;

                case 2:
                    this.value = {
                        ...this.value,
                        package_type: type,
                        length: '35',
                        width: '25',
                        height: '3',
                        weight: '0.5'
                    };
                    break;

                case 3:
                    this.value = {
                        ...this.value,
                        package_type: type,
                        length: '120',
                        width: '80',
                        height: '60',
                        weight: '100'
                    };
                    break;
            }
        },
        getClassCarrier(carrier) {
            let _class = 'courier-button--' + carrier.carrier_code;
            if (carrier.carrier_code === this.carrierSelect.carrier_code)
                _class += ' selected';
            return _class;
        },
        setCarrierSelect(carrier, manually=false){
            this.carrierSelect = carrier;
            if(!!manually)
                this.manually = true;
        },
        cheapestCarrier() {
            const cheapestCarrier = getCheapestCarrier(this.carriers);
            if (!cheapestCarrier) {
                return null;
            }
            return cheapestCarrier;
        }
    },
    watch: {
        value: {
            deep: true,
            handler: debounce(function(){
                this.load();
            }, 500)

        }
    },
    computed: {
        priceComponent() {
            return 'PriceInfo' + (this.ABVersion || 'v3').toUpperCase();
        },
        isPriceAvailable() {
            return this.quotation && Array.isArray(this.quotation.products) && this.quotation
                .products
                .filter(filterOutProductWithoutOffer)
                .length > 0;
        },
        weightMask() {
            if (String(this.value.package_type) !== '2') {
                return /^[0-9]+$/;
            }
        },
        carriers() {
            let carriers = [];
            if(this.quotation) {
                for (let product of this.quotation.products) {
                    if (!product.no_offer) {
                        carriers.push({
                            ...this.carrierNames[product.carrier_code],
                            'carrier_code': product.carrier_code,
                            'product_id': product.id,
                            'total': (product.total / 100).toFixed(2)
                        })
                    }
                }
            }
            return carriers;
        }
    },
    template: `
        <form class="quick-order-form" action="/" @submit.prevent="onSubmit" autocomplete="off">
          <div class="quick-order-form__left">
            <div class="quick-order-form__section quick-order-form__section--parcel">
                <header class="quick-order-form__section__header">
                    <p class="quick-order-form__section__label">Co chcesz wysłać?</p>
                </header>
                <div class="quick-order-form__section__content">
                    <ParcelType :value="value.package_type" @input="onTypeChange"/>
                </div>
            </div>
            
            <div class="quick-order-form__section quick-order-form__section--params">
                <header class="quick-order-form__section__header">
                    <p class="quick-order-form__section__label">Parametry przesyłki</p>
                </header>
                <div class="quick-order-form__section__content">
                  <div class="quick-order-form__section__content-part">
                    <FormField type="text"
                                suffix="kg"
                                :mask="weightMask"
                                :value="value.weight"
                                @input="value.weight = $event.replace(/,/g, '.')"
                                suffixWidth="40"
                                inputmode="numeric"
                                label="Waga"
                                :invalid="errors.has('weight')"
                                :disabled="value.package_type === 2"
                                @blur="validateField('weight')"
                                data-field="weight"
                                name="weight"/>
                    <div class="quick-order-form__size">
                        <FormField :value="value.length"
                                    label="Długość"
                                    type="custom"
                                    data-field="length">
                            <PackageLength v-model="value.length"
                                            label="Dł."
                                            @validateRequestField="validateField"
                                            :invalid="errors.has('length')"
                                            :packageType="value.package_type"/>
                        </FormField>
                        <FormField :value="value.width"
                                    type="custom"
                                    label="Szerokość"
                                    data-field="width">
                            <PackageWidth v-model="value.width"
                                            @validateRequestField="validateField"
                                            label="Szer."
                                            :invalid="errors.has('width')"
                                            :packageType="value.package_type"/>
                        </FormField>
                        <FormField :value="value.height"
                                    type="custom"
                                    label="Wysokość"
                                    data-field="height">
                            <PackageHeight v-model="value.height"
                                            @validateRequestField="validateField"
                                            label="Wys."
                                            :invalid="errors.has('height')"
                                            :packageType="value.package_type"/>
                        </FormField>
                    </div>
                  </div>
                  <div class="quick-order-form__countries">
                        <FormField value="1"
                                    label="Kraj nadania"
                                    type="custom"
                                    data-field="countryFrom">
                                <Country v-model="value.countryFrom" :onlySendFrom="true" id="countryFrom"/>
                        </FormField>
                        <FormField value="1"
                                    label="Kraj odbioru"
                                    type="custom"
                                    data-field="countryTo">
                                <Country v-model="value.countryTo" id="countryTo"/>
                        </FormField>
                    </div>
                </div>
            </div>
          </div>
          <div class="quick-order-form__right">
                <div class="quick-order-form__section quick-order-form__section--carriers">                  
                    <header class="quick-order-form__section__header">
                        <p class="quick-order-form__section__label">Firmy kurierskie</p>
                    </header>                  
                    <div class="quick-order-form__section__content">
                        <div class="quick-order-form__prices" ref="stickyDiv" >
                          <div v-for="carrier in carriers" class="quick-order-form__price" :class="getClassCarrier(carrier)" @click="setCarrierSelect(carrier, true)">
                              <span class="label">
                                <span class="name">{{carrier.name}}</span>
                                <span class="subname" v-if="!!carrier.subname">{{carrier.subname}}</span>
                              </span>
                              <span class="price">{{carrier.total}} zł</span>
                            </div>
                        </div>
                        <div class="quick-order-form__price-sticky" :class="{ fixed: isFixed }">
                            <div class="quick-order-form__price-info"
                                    :is="priceComponent"
                                    :isLoading="isLoading"
                                    :quotation="quotation"
                                    :carrierSelect="carrierSelect"
                                    @selected="submit"></div>
                            <button class="button button--secondary quick-order-form__submit" :disabled="!isPriceAvailable" @click="submit">Dodaj przesyłkę</button>
                        </div>
                    </div>      
                </div>
          </div>
          
        </form>
    `
};

export const QuickOrderFormToggler = {
    name: 'QuickOrderFormToggler',
    data() {
        return {
            isOpen: this.defaultIsOpen,
            doRender: this.defaultIsOpen,
            defaultValue: this.getDefaultValueFromSchema(global.quotation_schema)
        };
    },
    props: {
        ABVersion: String,
        defaultIsOpen: {
            type: Boolean,
            default: false
        }
    },
    components: {
        QuickOrderForm
    },
    computed: {
        classes() {
            return [
                'quick-order-form-toggler',
                this.isOpen && 'quick-order-form-toggler--open'
            ];
        }
    },
    methods: {
        open() {
            this.isOpen = true;
            this.doRender = true;
        },
        close() {
            this.isOpen = false;
        },
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        setCountries(from, to) {
            this.$refs.form.setCountries(from, to);
        },
        getDefaultValueFromSchema(schema) {
            if (!schema) {
                return {};
            }

            const result = {};

            for (const key of Object.keys(schema)) {
                const value = schema[key];

                if (value === null || value === undefined) {
                    continue;
                }

                switch (key) {
                    case 'country_from':
                        result.countryFrom = value;
                        break;

                    case 'country_to':
                        result.countryTo = value;
                        break;
                }
            }

            return result;
        }
    },
    template: `
        <div :class="classes">
            <QuickOrderForm v-if="doRender" :ABVersion="ABVersion" ref="form" :default-value="defaultValue"/>
        </div>
    `
};


// ----------------------------------------------------- OLD -----------------------------------------------------------

// function getCheapestProduct(products) {
//     if (!Array.isArray(products)) {
//         return;
//     }
//     return products.filter(filterOutProductWithoutOffer).sort((a, b) => a.total - b.total)[0];
// }
//
// const PriceInfoV1 = {
//     name: 'PriceInfoV1',
//     components: {
//         CarrierPrice,
//         Loader
//     },
//     props: {
//         isLoading: Boolean,
//         quotation: Object
//     },
//     computed: {
//         products() {
//             if (this.quotation) {
//                 return this.quotation.products
//             }
//         }
//     },
//     template: `
//         <div class="quick-order-form__price-info--v1">
//             <template v-for="product in products">
//                 <CarrierPrice :code="product.carrier_code"
//                             :id="product.id"
//                             :isLoading="isLoading"
//                             :price="product.total"
//                             :isSelectable="true"
//                             @selected="$emit('selected')"
//                             size="small"/>
//             </template>
//         </div>
//     `
// };
//
// const PriceInfoV2 = {
//     name: 'PriceInfoV2',
//     components: {
//         CarrierPrice
//     },
//     props: {
//         quotation: Object,
//         isLoading: Boolean
//     },
//     computed: {
//         product() {
//             if (this.quotation) {
//                 return getCheapestProduct(this.quotation.products);
//             }
//         },
//         isAvailable() {
//             return this.quotation && this.quotation.products.length > 0;
//         }
//     },
//     template: `
//         <div class="quick-order-form__price-info--v2">
//             <div class="quick-order-form__price-info__description">Najtańszy kurier:</div>
//             <div>
//                 <CarrierPrice v-if="isAvailable"
//                             :code="product.carrier_code"
//                             :id="product.id"
//                             :isLoading="isLoading"
//                             :price="product.total"
//                             :isSelectable="true"
//                             @selected="$emit('selected')"
//                             size="small"/>
//             </div>
//         </div>
//     `
// };
//
// export const QuickOrderFormOld = {
//     name: 'QuickOrderFormOld',
//     components: {
//         FormField,
//         ParcelType,
//         Country,
//         PriceInfoV1,
//         PriceInfoV2,
//         PriceInfoV3,
//         PackageWidth,
//         PackageLength,
//         PackageHeight
//     },
//     props: {
//         ABVersion: String,
//         defaultValue: Object,
//         baseUrl: String
//     },
//     data() {
//         return {
//             value: {
//                 package_type: 1,
//                 weight: 1,
//                 width: 20,
//                 height: 8,
//                 length: 25,
//                 countryFrom: 'PL',
//                 countryTo: 'PL',
//                 ...(this.defaultValue || {})
//             },
//             isLoading: false,
//             quotation: undefined,
//             errors: new ErrorBag()
//         };
//     },
//     mounted() {
//         this.validator = new Validator(
//             yup.object({
//                 weight: yup.number()
//                     .required()
//                     .typeError(),
//                 length: yup.number()
//                     .required()
//                     .typeError()
//                     .min(1),
//                 height: yup.number()
//                     .required()
//                     .typeError()
//                     .min(1),
//                 width: yup.number()
//                     .required()
//                     .typeError()
//                     .min(1),
//             })
//         );
//         this.errors = this.validator.errors;
//         this.load();
//     },
//     methods: {
//         load() {
//             this.validate()
//                 .then(isValid => {
//                     if (!isValid) {
//                         // create empty result to indiate lack of products
//                         this.quotation = {products: []};
//                         return;
//                     }
//
//                     this.isLoading = true;
//
//                     quotation({
//                         sender: {
//                             country: this.value.countryFrom
//                         },
//                         recipient: {
//                             country: this.value.countryTo
//                         },
//                         params: {
//                             weight: this.value.weight,
//                             height: this.value.height,
//                             length: this.value.length,
//                             width: this.value.width,
//                             package_type: this.value.package_type,
//                             count: 1,
//                             packing_type: 1,
//                             content: ""
//                         },
//                         services: {}
//                     })
//                         .then(result => {
//                             this.isLoading = false;
//                             this.quotation = result;
//                         })
//                         .catch(() => {
//                             this.isLoading = false;
//                         });
//                 })
//         },
//         validateField(field) {
//             return this.validator.validateField(field, this.value);
//         },
//         validate() {
//             return this.validator.validate(this.value);
//         },
//         onSubmit() {},
//         submit() {
//             this.validate()
//                 .then(isValid => {
//                     if (!isValid) {
//                         return;
//                     }
//                     const data = {
//                         params: {
//                             length: this.value.length,
//                             width: this.value.width,
//                             height: this.value.height,
//                             weight: this.value.weight,
//                             package_type: this.value.package_type,
//                         },
//                         sender: {
//                             country: this.value.countryFrom,
//                         },
//                         recipient: {
//                             country: this.value.countryTo
//                         }
//                     };
//
//                     if(this.$parent.type === 'widget')
//                     {
//                         let target = '_blank'
//                         if(this.$parent.$el.classList.contains('same_tab')) {
//                             target = '_self';
//                         }
//                         window.open((this.baseUrl || '') + 'zloz-zamowienie?d=' + JSON.stringify(data), target);
//                     }
//                     else
//                     {
//                         submitForm((this.baseUrl || '') + 'zloz-zamowienie', {
//                             method: 'GET',
//                             body: {
//                                 d: JSON.stringify(data)
//                             }
//                         });
//                     }
//
//                 });
//         },
//         setCountries(from, to) {
//             this.value.countryFrom = from;
//             this.value.countryTo = to;
//         },
//         onTypeChange(type) {
//             switch (type) {
//                 case 1:
//                     this.value = {
//                         ...this.value,
//                         package_type: type,
//                         length: '25',
//                         width: '20',
//                         height: '8',
//                         weight: '1'
//                     };
//                     break;
//
//                 case 2:
//                     this.value = {
//                         ...this.value,
//                         package_type: type,
//                         length: '35',
//                         width: '25',
//                         height: '3',
//                         weight: '0.5'
//                     };
//                     break;
//
//                 case 3:
//                     this.value = {
//                         ...this.value,
//                         package_type: type,
//                         length: '120',
//                         width: '80',
//                         height: '60',
//                         weight: '100'
//                     };
//                     break;
//             }
//         }
//     },
//     watch: {
//         value: {
//             deep: true,
//             handler: debounce(function(){
//                 this.load();
//             }, 500)
//
//         }
//     },
//     computed: {
//         priceComponent() {
//             return 'PriceInfo' + (this.ABVersion || 'v3').toUpperCase();
//         },
//         isPriceAvailable() {
//             return this.quotation && Array.isArray(this.quotation.products) && this.quotation
//                 .products
//                 .filter(filterOutProductWithoutOffer)
//                 .length > 0;
//         },
//         weightMask() {
//             if (String(this.value.package_type) !== '2') {
//                 return /^[0-9]+$/;
//             }
//         }
//     },
//     template: `
//         <form class="quick-order-form" action="/" @submit.prevent="onSubmit" autocomplete="off">
//             <div class="quick-order-form__section quick-order-form__section--parcel">
//                 <header class="quick-order-form__section__header">
//                     <p class="quick-order-form__section__label">Co chcesz wysłać?</p>
//                 </header>
//                 <div class="quick-order-form__section__content">
//                     <ParcelType :value="value.package_type" @input="onTypeChange"/>
//                 </div>
//             </div>
//             <div style="display: flex; flex-direction: column;">
//                 <div class="quick-order-form__section quick-order-form__section--params">
//                     <header class="quick-order-form__section__header">
//                         <p class="quick-order-form__section__label">Parametry przesyłki</p>
//                     </header>
//                     <div class="quick-order-form__section__content">
//                       <div class="quick-order-form__section__content-part">
//                         <FormField type="text"
//                                     suffix="kg"
//                                     :mask="weightMask"
//                                     :value="value.weight"
//                                     @input="value.weight = $event.replace(/,/g, '.')"
//                                     suffixWidth="40"
//                                     inputmode="numeric"
//                                     label="Waga"
//                                     :invalid="errors.has('weight')"
//                                     :disabled="value.package_type === 2"
//                                     @blur="validateField('weight')"
//                                     data-field="weight"
//                                     name="weight"/>
//                         <div class="quick-order-form__size">
//                             <FormField :value="value.length"
//                                         label="Długość"
//                                         type="custom"
//                                         data-field="length">
//                                 <PackageLength v-model="value.length"
//                                                 label="Dł."
//                                                 @validateRequestField="validateField"
//                                                 :invalid="errors.has('length')"
//                                                 :packageType="value.package_type"/>
//                             </FormField>
//                             <FormField :value="value.width"
//                                         type="custom"
//                                         label="Szerokość"
//                                         data-field="width">
//                                 <PackageWidth v-model="value.width"
//                                                 @validateRequestField="validateField"
//                                                 label="Szer."
//                                                 :invalid="errors.has('width')"
//                                                 :packageType="value.package_type"/>
//                             </FormField>
//                             <FormField :value="value.height"
//                                         type="custom"
//                                         label="Wysokość"
//                                         data-field="height">
//                                 <PackageHeight v-model="value.height"
//                                                 @validateRequestField="validateField"
//                                                 label="Wys."
//                                                 :invalid="errors.has('height')"
//                                                 :packageType="value.package_type"/>
//                             </FormField>
//                         </div>
//                       </div>
//                       <div class="quick-order-form__countries">
//                             <FormField value="1"
//                                         label="Kraj nadania"
//                                         type="custom"
//                                         data-field="countryFrom">
//                                     <Country v-model="value.countryFrom" :onlySendFrom="true" id="countryFrom"/>
//                             </FormField>
//                             <FormField value="1"
//                                         label="Kraj odbioru"
//                                         type="custom"
//                                         data-field="countryTo">
//                                     <Country v-model="value.countryTo" id="countryTo"/>
//                             </FormField>
//                         </div>
//                     </div>
//                 </div>
//                 <div class="quick-order-form__section quick-order-form__section--carriers">
//                     <div class="quick-order-form__price-info"
//                             :is="priceComponent"
//                             :isLoading="isLoading"
//                             :quotation="quotation"
//                             @selected="submit"></div>
//                     <button class="button button--secondary quick-order-form__submit" :disabled="!isPriceAvailable" @click="submit">Dodaj przesyłkę</button>
//                 </div>
//             </div>
//         </form>
//     `
// };



